/**
 * @generated SignedSource<<00b7c640f8e4013e08f5e9404b663ea2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferVisibility_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useOfferVisibility_viewer">;
  readonly " $fragmentType": "OfferVisibility_viewer";
};
export type OfferVisibility_viewer$key = {
  readonly " $data"?: OfferVisibility_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfferVisibility_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferVisibility_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useOfferVisibility_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d2bdd0d9a3342a9821999de06bd579c3";

export default node;
